export default "__VITE_ASSET__b3396e6d__$_?nuxt_component=async&nuxt_component_name=SvgoClockHour__"